import type { StorageQuotaInfo } from "@repo/api";

/** 与后端统一存储一致，按十进制 GB（1000³）换算 */
export const GB_IN_BYTES = 1000 ** 3;

export type QuotaProgressColor = "accent" | "warning" | "danger";

/** 配额文案固定为 GB，例如 1.25GB */
export function formatStorageGB(bytes: number): string {
  return `${(bytes / GB_IN_BYTES).toFixed(2)}GB`;
}

export function getQuotaProgressColor(usedBytes: number, maxBytes: number): QuotaProgressColor {
  if (maxBytes <= 0) {
    return "accent";
  }
  const ratio = usedBytes / maxBytes;
  if (ratio > 0.9) {
    return "danger";
  }
  if (ratio > 0.5) {
    return "warning";
  }
  return "accent";
}

export function getQuotaUsageText(usedBytes: number, maxBytes: number): string {
  return `${formatStorageGB(usedBytes)}/${formatStorageGB(maxBytes)}`;
}

/** 已用空间大于可用配额，或总配额为 0 时视为容量不足 */
export function isStorageQuotaExhausted(info?: StorageQuotaInfo | null): boolean {
  if (!info) {
    return false;
  }
  return info.used > info.count || info.count <= 0;
}

const SEVEN_DAYS_IN_SECONDS = 7 * 24 * 60 * 60;

/** expire 为 Unix 秒；0 表示永久。剩余有效期不足 7 天（且尚未过期）时视为即将到期 */
export function isStorageQuotaExpiringSoon(
  expire: number,
  nowSec = Math.floor(Date.now() / 1000),
): boolean {
  if (!expire || expire <= nowSec) {
    return false;
  }
  return expire - nowSec < SEVEN_DAYS_IN_SECONDS;
}
